import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { OrderRepositoryImpl } from "../../domain/orderRepositoryImpl/OrderRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const orderRepo = OrderRepositoryImpl.getInstance();

const useGetCompletedOrders = () => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { isLoading, data } = useQuery(
    {
      queryKey: ["useGetCompletedOrders", auth],
      queryFn: async () => {
        return await orderRepo.getCompletedOrderList(auth, apiUrl);
      },
      enabled: Boolean(auth),
    },
    queryClient,
  );

  return { orders: data || [], isLoading };
};

export { useGetCompletedOrders };
